import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivity = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 12,
	viewBox: "0 0 25 12",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M 2.707031 10.042969 L 1.328125 10.042969 C 0.78125 10.042969 0.367188 9.644531 0.367188 9.109375 L 0.367188 2.890625 C 0.367188 2.355469 0.78125 1.957031 1.328125 1.957031 L 2.707031 1.957031 Z M 2.707031 10.042969 "
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M 22.496094 1.957031 L 24.054688 1.957031 C 24.46875 1.957031 24.835938 2.3125 24.835938 2.710938 L 24.835938 9.246094 C 24.835938 9.644531 24.46875 10 24.054688 10 L 22.496094 10 Z M 22.496094 1.957031 "
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M 20.617188 0.179688 L 17.59375 0.179688 C 17.273438 0.179688 17 0.445312 17 0.753906 L 17 4.753906 L 8.203125 4.753906 L 8.203125 0.753906 C 8.203125 0.445312 7.925781 0.179688 7.609375 0.179688 L 4.582031 0.179688 C 4.261719 0.179688 3.984375 0.445312 3.984375 0.753906 L 3.984375 11.289062 C 3.984375 11.601562 4.261719 11.867188 4.582031 11.867188 L 7.609375 11.867188 C 7.925781 11.867188 8.203125 11.601562 8.203125 11.289062 L 8.203125 7.289062 L 17 7.289062 L 17 11.289062 C 17 11.601562 17.273438 11.867188 17.59375 11.867188 L 20.617188 11.867188 C 20.941406 11.867188 21.214844 11.601562 21.214844 11.289062 L 21.214844 0.753906 C 21.167969 0.445312 20.941406 0.179688 20.617188 0.179688 Z M 20.617188 0.179688 "
		})
	]
});
export default SvgActivity;
